<template>
	<div>
		<div class="upper_div"></div>
		<div class="bgImg">
			<div class="formBox">
				<div class="titleContainer">
					<h1 class="title">אתר הנדל"ן הממשלתי – התחברות</h1>
					<p class="plainText">חדש – מעקב אחר נכסים</p>
				</div>
				<div class="formContainer" autocomplete="off">
					<div class="inputContainer">
						<input
							v-model="email"
							name="emailAddress"
							class="genericInput"
							type="email"
							autocomplete="off"
							maxlength="50"
							placeholder="דואר אלקטרוני"
							value=""
						/>
						<!-- <button class="editBtn"></button> -->
					</div>
					<div class="inputContainer">
						<input
							v-model="password"
							name="password"
							class="genericInput"
							type="password"
							autocomplete="on"
							maxlength="20"
							placeholder="סיסמה"
							value=""
						/>
						<!-- <button class="editBtn"></button> -->
					</div>
					<a
						v-if="errorText == 'יש לאמת את החשבון'"
						style="cursor: pointer; color: red"
						class="link linkUnderline"
						@click="resendToken()"
						>יש לאמת את החשבון</a
					>
					<div style="height: 30px">
						<p
							v-if="errorText != '' && errorText != 'יש לאמת את החשבון'"
							style="color: red"
							class="plainText"
						>
							{{ errorText }}
						</p>
					</div>
					<button
						@click="logIn"
						:disabled="!email || !password"
						class="btn blue"
					>
						התחברות
					</button>
					<a
						style="cursor: pointer"
						class="link linkUnderline"
						@click="sendResetToken()"
						>שכחתי סיסמה</a
					>
					<a class="link linkUnderline" href="/?view=register"
						>עדיין אין לכם משתמש? הירשמו עכשיו</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script src="https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT"></script>

<script>
export default {
	data() {
		return {
			email: "",
			password: "",
			errorText: "",
			recaptchaToken: '', // Store the reCAPTCHA token here
		};
	},
	methods: {
		loadRecaptchaScript() {
			// Check if the reCAPTCHA script is already added to avoid multiple loads
			if (!document.getElementById('recaptcha-script')) {
				const script = document.createElement('script');
				script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT';
				script.id = 'recaptcha-script';
				script.onload = this.onRecaptchaScriptLoaded;
				document.head.appendChild(script);
			} else {
				this.onRecaptchaScriptLoaded(); // Script already loaded, proceed
			}
		},
		onRecaptchaScriptLoaded() {
			// Once the script is loaded, initialize reCAPTCHA
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		refreshRecaptcha() {
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		sendResetToken() {
			var appVue = this;
			appVue.$store.state.useremail = this.email;
			this.mixin_setCookie("useremail", this.email);
			appVue.$store.state.userTokenType = "reset";
			sessionStorage.setItem("userTokenType", "reset");
			
			appVue.mixin_goTo(appVue, "approve");
		},
		resendToken() {
			var appVue = this;
			//ReSend Token
			appVue
				.mixin_sendToken(appVue, "verif", this.emailAddress)
				.then((token_res) => {
					// Do something with the result
					appVue.$store.state.userTokenType = "verif";
					// set on the local storage
					sessionStorage.setItem("userTokenType", "verif");
					appVue.mixin_goTo(appVue, "approve");
				})
				.catch((error) => {
					console.error("error", error);
					// Handle any errors that occurred during the asynchronous operation
				});
		},
		logIn1() {
			this.errorText = "";
			var emailAddress = this.email;
			var password = this.password;
			var appVue = this;
			if (emailAddress != null && password != null) {
				
				appVue.$store.state.useremail = emailAddress;
				appVue.$store.state.password = password;

				appVue.mixin_login(appVue, emailAddress, password).then((login_res) => {
					
					//show in the UI (this.errorText == login_res.data.message)
					if (login_res.statusCode != 200) {
						//TODO: if no message in the response
						if (401 == login_res.statusCode) {
							
							// save userName to store.state.username
							appVue.$store.state.username = login_res.data.userName;
							appVue.errorText = login_res.data.message;
							//this.mixin_setCookie("pwd", password);
							var obj = {
								"pwd": password,
							};
							var compressed = this.compressBase64Gzip(JSON.stringify(obj));
							this.mixin_setCookie("up", compressed);
							if (login_res.data.message == "סיסמה שגויה"){
								appVue.errorText = "סיסמא שגויה";
								return;
							}
							appVue.$store.state.currentUser = login_res.data;
							appVue.$store.state.currentUser.addressList = [];
							appVue.mixin_goTo(appVue, 'approve');
						}
						
						appVue.errorText = login_res.data.message;
						return;
						// go to approve
						//appVue.mixin_goTo(appVue, 'approve');
					}
					else{
						appVue.$store.state.userid = login_res.data.userID;
						appVue.$store.state.username = login_res.data.userName;

						appVue.$store.state.currentUser = {
							userid: login_res.data.userID,
							useremail: appVue.$store.state.useremail,
							username: login_res.data.userName,
							addressList: [],
						};
						// Remove all cookies
						// this.mixin_removeCookie('user');
						// this.mixin_removeCookie("pwd");
						this.mixin_removeCookie("up");
						// Set cookies
						// encript appVue.$store.state.currentUser
						// string currentUser json
						var jsonString = JSON.stringify(appVue.$store.state.currentUser);
						var compressed = appVue.compressBase64Gzip(jsonString);
						this.mixin_setCookie("user", compressed);
						
						if (this.mixin_getCookie("user")){
							var decompressed = appVue.decompressBase64Gzip(this.mixin_getCookie("user"));
							appVue.$store.state.currentUser = decompressed;
							appVue.mixin_goTo(appVue, "home");
						}
					}
					
				});
			}
		},
		logIn() {
			// Call the mixin method
			this.mixin_handleLogin();
		},
	},
	mounted() {
		this.loadRecaptchaScript();
	},
};
</script>

<style></style>
